import React from "react";
import LegalDocument from "components/LegalDocument/LegalDocument";
import { getResidenceTerms } from "data/legalTerms";
import { useLocale } from "i18n/locale";

const TermsOfUse = () => {
    const { locale } = useLocale();
    return <LegalDocument blocks={getResidenceTerms(locale)} />;
};

export default TermsOfUse;
